module.exports = __webpack_public_path__ + "static/media/flag-fy.f8450f8a.svg";